import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpRequestService} from '../../shared/services/http-request.service';
import {environment} from '../../../environments/environment';
import {GridService} from '../../shared/services/grid.service';


@Injectable()
export class GroupDatabaseService extends GridService {

  private groupDatabaseURL = environment.apiUrl + '/VenueCms/GetVenueGroups';
  private getGroupDetailsURL = environment.apiUrl + '/VenueCms/GetGroupDetails';
  private getGroupDatabaseAnalyticsUrl = environment.apiUrl + '/VenueCms/GetGroupDatabaseAnalytics';

  constructor(private http: HttpRequestService) {super();
    this.getData = this.getGroups;
  }
  public getGroups(data) {
    return this.http.post(this.groupDatabaseURL, data);
  }

  public getGroupDetails(id: number) {
    return this.http.get(this.getGroupDetailsURL + '?id=' + id);
  }

  public getGroupDatabaseAnalytics() {
    return this.http.get(this.getGroupDatabaseAnalyticsUrl);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/group-database/group-database.service.ts